import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  /* max-width: 400px; */
  margin: 0 auto;
`;